// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IPolicyElectionDto
 */
export interface IPolicyElectionDto {
    /**
     * 
     * @type {number}
     * @memberof IPolicyElectionDto
     */
    id?: number;
    /**
     * 
     * @type {number}
     * @memberof IPolicyElectionDto
     */
    policy_id?: number;
    /**
     * 
     * @type {number}
     * @memberof IPolicyElectionDto
     */
    amount?: number;
    /**
     * 
     * @type {Date}
     * @memberof IPolicyElectionDto
     */
    valid_from?: Date;
    /**
     * 
     * @type {Date}
     * @memberof IPolicyElectionDto
     */
    valid_to?: Date;
    /**
     * 
     * @type {boolean}
     * @memberof IPolicyElectionDto
     * @deprecated
     */
    is_funded?: boolean;
}

/**
 * Check if a given object implements the IPolicyElectionDto interface.
 */
export function instanceOfIPolicyElectionDto(value: object): value is IPolicyElectionDto {
    return true;
}

export function IPolicyElectionDtoFromJSON(json: any): IPolicyElectionDto {
    return IPolicyElectionDtoFromJSONTyped(json, false);
}

export function IPolicyElectionDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IPolicyElectionDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'policy_id': json['policy_id'] == null ? undefined : json['policy_id'],
        'amount': json['amount'] == null ? undefined : json['amount'],
        'valid_from': json['valid_from'] == null ? undefined : (new Date(json['valid_from'])),
        'valid_to': json['valid_to'] == null ? undefined : (new Date(json['valid_to'])),
        'is_funded': json['is_funded'] == null ? undefined : json['is_funded'],
    };
}

export function IPolicyElectionDtoToJSON(json: any): IPolicyElectionDto {
    return IPolicyElectionDtoToJSONTyped(json, false);
}

export function IPolicyElectionDtoToJSONTyped(value?: IPolicyElectionDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'policy_id': value['policy_id'],
        'amount': value['amount'],
        'valid_from': value['valid_from'] == null ? undefined : ((value['valid_from']).toISOString().substring(0,10)),
        'valid_to': value['valid_to'] == null ? undefined : ((value['valid_to']).toISOString().substring(0,10)),
        'is_funded': value['is_funded'],
    };
}

